import React, { useEffect } from "react";
import { Footer2, Navbar2 } from "../components";

const NotFoundPage = () => {
    useEffect(() => {
        document.title = "Error 404";
      }, []);
  return (
    <div
      className="text-center"
      style={{ padding: "100px 3rem 3rem" }}
    >
      <Navbar2 />
      <h2 className="p-5" style={{ color: "#f2e9e7" }}>
        Page Not Found
      </h2>
      {/* <Footer2 /> */}
    </div>
  );
};

export default NotFoundPage;
